module.exports = __webpack_public_path__ + "img/vexere.70e26651.png";